<template>
  <div>
    <span class="count_top">
      <i
        class="fa fa-file-text-o"
        aria-hidden="true"></i> PO#
    </span>
    <div class="count">
      <p>{{ item.poId }}</p>
    </div>
    <el-dialog
      title="Add a PO EXCEL or HTML file:"
      :visible.sync="updatePOFormVisible">
      <el-upload
        class="upload-demo"
        drag
        ref="upload"
        :action="getUploadUrl"
        :headers="getHeaders"
        :file-list="fileList"
        :on-error="uploadError"
        :on-success="uploadSucess"
        accept=".xls,.xlsx,.html">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
        <div
          slot="tip"
          class="el-upload__tip">Accepted files .html or .xlsx/.xls
        </div>
      </el-upload>
    </el-dialog>

    <span
      class="count_bottom"
      v-if="isInternal">
      Internal
      <el-tooltip
        placement="top"
        v-if="isInternal">
        <div
          slot="content"
          style="text-transform: uppercase;">
          This PO is for a Zee.Dog shipping station in China, thus there is no Handed Over state
        </div>
        <i class="el-icon-information" ></i>
      </el-tooltip>
    </span>
  </div>
</template>

<script>
import apiUrl from '@/services/api_url';
import getFileUploadHeaders from '@/services/http-file-headers';

export default {
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
    isInternal: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      updatePOFormVisible: false,
      isUploading: false,
      fileList: [],
    };
  },
  computed: {
    getUploadUrl() {
      return `${apiUrl}pos/`;
    },
    getHeaders() {
      return getFileUploadHeaders();
    },
  },
  methods: {
    submitUpload() {
      if (this.$refs.upload.$children[0].fileList[0]) {
        this.isUploading = true;
        this.$refs.upload.submit();
      } else {
        this.$message.warning('You need to select a file');
      }
    },
    uploadError() {
      this.isUploading = false;
      this.$message.error('Something went wrong. Try again.');
    },
    uploadSucess(response) {
      this.createdPoId = response.id;
      this.isUploading = false;
      this.$message({
        message: 'Success! PO updated.',
        type: 'success',
      });
      this.updatePOFormVisible = false;
    },
  },
};

</script>

<style lang="scss" scoped>
.el-upload {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/purchase-orders/purchase-order/partials/PoID.vue